import { DateTime, type DateTimeInput } from 'scaleflow/utils/date-time';

/**
 * `{{format-date value "DD MMM, YYYY"}}` — replaces ember-moment's
 * `moment-format`. A missing value formats now; an unparseable one renders
 * "Invalid date".
 */
export default function formatDate(
  value: DateTimeInput,
  pattern: string,
): string {
  return DateTime.from(value).format(pattern);
}
